import React from 'react';
import { isImage, isPDF } from '../../../utils/documents';
import PDFViewer from '../shipments/PDFViewer';
export function DocumentsPreview({ files, placeholder = '' }) {
    return (React.createElement("div", null, files.map((file, index) => {
        let fileType = file.type;
        if (isPDF(fileType)) {
            return (React.createElement("div", { key: index },
                React.createElement(PDFViewer, { file: file })));
        }
        if (isImage(fileType)) {
            return (React.createElement("div", { key: index },
                React.createElement("img", { width: "100%", height: "100%", alt: "Preview", src: file.preview ? file.preview : placeholder })));
        }
        return React.createElement("div", { key: index }, file.name || placeholder);
    })));
}
